<!-- Skeleton variant — same card shell, pulsing icon circle + live progress
     label + shimmer bar where the Download button will land. -->
<div class="deliverable-card" *ngIf="loading; else loadedCard">
    <div class="deliverable-head">
        <span class="deliverable-icon is-loading">
            <!-- Generic glyph on purpose — output format isn't known until the file lands. -->
            <i class="ph-bold ph-file icon-muted icon-24" aria-hidden="true"></i>
        </span>
        <div class="deliverable-meta">
            <div class="deliverable-title is-loading">{{ loadingLabel || 'Building the document…' }}</div>
            <div class="deliverable-sub" *ngIf="loadingHint">{{ loadingHint }}</div>
        </div>
    </div>

    <div class="deliverable-actions">
        <span class="deliverable-action-shimmer" aria-hidden="true"></span>
    </div>
</div>

<ng-template #loadedCard>
<div class="deliverable-card">
    <div class="deliverable-head">
        <span class="deliverable-icon">
            <i class="ph-bold {{ iconFor(primaryFile?.format || '') }} icon-primary icon-24" aria-hidden="true"></i>
        </span>
        <div class="deliverable-meta">
            <div class="deliverable-title">{{ title }}</div>
            <div class="deliverable-sub" *ngIf="primaryFile">
                {{ primaryFile.fileName }} · {{ primaryFile.sizeLabel }}
            </div>
        </div>
    </div>

    <div class="deliverable-actions">
        <ng-container *ngIf="files.length > 1; else singleDownload">
            <button mat-flat-button
                    color="primary"
                    type="button"
                    [disableRipple]="true"
                    [matMenuTriggerFor]="downloadMenu">
                <i class="ph-bold ph-download-simple icon-16" aria-hidden="true"></i>
                Download
                <i class="ph-bold ph-caret-down icon-16" aria-hidden="true"></i>
            </button>
            <mat-menu #downloadMenu="matMenu" class="gable-menu-panel">
                <a *ngFor="let f of files; trackBy: trackByFormat"
                   mat-menu-item
                   [href]="f.downloadUrl"
                   target="_blank" rel="noopener noreferrer">
                    {{ formatLabel(f.format) }}
                </a>
            </mat-menu>
        </ng-container>

        <ng-template #singleDownload>
            <a *ngIf="primaryFile"
               mat-flat-button
               color="primary"
               [disableRipple]="true"
               [href]="primaryFile.downloadUrl"
               target="_blank" rel="noopener noreferrer">
                <i class="ph-bold ph-download-simple icon-16" aria-hidden="true"></i>
                Download {{ formatLabel(primaryFile.format) }}
            </a>
        </ng-template>
    </div>
</div>
</ng-template>
